
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#677787","stroke-width":"1.326","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M3.727 6.36H9.03M3.727 10.337h3.315M3.727 14.314h3.315M13.008 6.36h1.325M10.703 15.034c.388.51 1 .8 1.642.773 1.006 0 1.822-.612 1.822-1.367s-.816-1.367-1.822-1.367c-1.007 0-1.824-.613-1.824-1.369 0-.755.817-1.367 1.824-1.367a1.965 1.965 0 011.642.773M12.345 15.807v.911M12.345 9.427v.91"}}),_c('path',{attrs:{"d":"M13.008 20.943a2.302 2.302 0 013.977 0V1.057A2.31 2.31 0 0114.996 2.2a2.31 2.31 0 01-1.988-1.143 2.31 2.31 0 01-1.99 1.143A2.31 2.31 0 019.03 1.057 2.31 2.31 0 017.042 2.2a2.31 2.31 0 01-1.989-1.143A2.31 2.31 0 013.064 2.2a2.31 2.31 0 01-1.988-1.143v19.886a2.302 2.302 0 013.977 0 2.302 2.302 0 013.977 0M9.03 19.943a2.302 2.302 0 013.978 0"}})])])
          )
        }
      }
    